module.exports = __webpack_public_path__ + "img/notification-icon-dark.0d58836c.svg";